var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBackspace = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 47,
  height: 47,
  viewBox: "0 0 47 47",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.0911 20.1999C21.6661 19.7748 21.6661 19.0858 22.0911 18.6608C22.5162 18.2357 23.2052 18.2357 23.6302 18.6608L27.2215 22.252L30.8126 18.6608C31.2376 18.2357 31.9266 18.2357 32.3517 18.6608C32.7767 19.0857 32.7767 19.7748 32.3517 20.1999L28.7604 23.791L32.3517 27.3822C32.7767 27.8072 32.7767 28.4963 32.3517 28.9212C31.9266 29.3463 31.2376 29.3463 30.8126 28.9212L27.2215 25.3301L23.6302 28.9212C23.2052 29.3463 22.5162 29.3463 22.0912 28.9212C21.6661 28.4962 21.6661 27.8072 22.0912 27.3822L25.6824 23.7911L22.0911 20.1999Z",
  fill: "#333333"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.6029 12.732L6.54395 23.791L17.6029 34.85C18.4193 35.6664 19.5266 36.125 20.6811 36.125H35.5651C37.9693 36.125 39.9182 34.176 39.9182 31.7718V15.8102C39.9182 13.406 37.9693 11.457 35.5651 11.457H20.6811C19.5266 11.457 18.4193 11.9157 17.6029 12.732ZM35.5651 34.2386H20.6811C20.0268 34.2386 19.3994 33.9787 18.9367 33.5161L9.21171 23.791L18.9367 14.0659C19.3994 13.6033 20.0268 13.3434 20.6811 13.3434H35.5651C36.9274 13.3434 38.0318 14.4478 38.0318 15.8102V31.7718C38.0318 33.1342 36.9274 34.2386 35.5651 34.2386Z",
  fill: "#333333"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBackspace, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/backspace.178169ae.svg";
export { ForwardRef as ReactComponent };